import React from 'react'
import styled, { css } from 'styled-components'

import { StyledContainer } from '../../utils/shared-styled-components'
import Container from '../../Layout/Container'

const StyledStyledContainer = styled(StyledContainer)`
  justify-content: center;
  width: 100%;
`

const StyledImageAndHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 42px 0px;
  width: 100%;

  ${props =>
    props.higherMargin &&
    css`
      margin-top: -160px;
    `}

  img {
    max-width: 100%;
  }
  
  ${({ theme }) => theme.media.desktop} {
    ${({ shiftY }) =>
      shiftY &&
      css`
        margin-top: 48px;
      `}

    ${({ bottomPadding }) =>
      bottomPadding &&
      css`
        margin-bottom: 88px;
      `}

    ${({ topPadding }) =>
      topPadding &&
      css`
        margin-top: 88px;
      `}
  }

  ${({ mobileReverse }) => mobileReverse && `flex-direction: column-reverse;`}

  ${({ theme }) => theme.media.desktop} {
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 0px;

    img {
      max-width: initial;
    }

    ${({ shift }) =>
      shift &&
      css`
        margin-left: -115px;
        width: calc(100% + 115px);
      `}

    ${({ smallPadding }) =>
      smallPadding &&
      css`
        // padding: 88px 0px 18px 0px;
      `}
  }
`

const StyledColumn = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;

  ${({ noMobileDisplay }) =>
    noMobileDisplay &&
    css`
      :first-child {
        display: none;
      }
    `}

  div {
    width: 100%;
  }

  img {
    max-width: 100%;
  }

  .gatsby-image-wrapper{
    overflow: visible !important
  }

  ${({ theme }) => theme.media.desktop} {
    display: flex;
    text-align: left;
    width: ${({ width }) => width};

    :first-child {
      display: flex;
    }

    ${({ left }) =>
      left &&
      css`
        img {
          max-width: 100%;
        }
      `}
      
    ${({ right }) =>
      right &&
      css`
        img {
          transform: translateX(66px);
        }
      `}
    }
  }
`

const ImageAndHeader = ({
  bottomPadding,
  cmsData,
  higherMargin,
  leftColumn,
  mobileReverse,
  noMobileDisplay,
  rightColumn,
  shiftX,
  smallPadding,
  topPadding,
}) => {
  var shiftedY = false
  if(cmsData && cmsData.leftColumn.fields.items[0].sys.contentType.sys.id === "languageCards"){
    shiftedY = true
  }

  return (
    <Container>
      <StyledStyledContainer>
        <StyledImageAndHeader
          bottomPadding={cmsData ? cmsData.bottomPadding : bottomPadding}
          higherMargin={cmsData ? cmsData.higherMargin : higherMargin}
          mobileReverse={mobileReverse}
          shift={shiftX}
          shiftY={shiftedY}
          smallPadding={smallPadding}
          topPadding={cmsData ? cmsData.topPadding : topPadding}
        >
          <StyledColumn 
            left="true" 
            noMobileDisplay={cmsData ? cmsData.noMobileDisplay : noMobileDisplay}
            width={leftColumn.width + '%'}
          >
            {leftColumn.data}
          </StyledColumn>
          <StyledColumn right="true" width={rightColumn.width + '%'}>
            {rightColumn.data}
          </StyledColumn>
        </StyledImageAndHeader>
      </StyledStyledContainer>
    </Container>
  )
}

export default ImageAndHeader
